import { render, staticRenderFns } from "./ExcBaseDropdown.vue?vue&type=template&id=99b3a442&scoped=true&"
import script from "./ExcBaseDropdown.vue?vue&type=script&lang=js&"
export * from "./ExcBaseDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ExcBaseDropdown.vue?vue&type=style&index=0&id=99b3a442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b3a442",
  null
  
)

export default component.exports